export default __webpack_public_path__ + "partials/post_card_image.hbs";